import * as React from 'react'

function MaleIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={93.876} height={59.4} viewBox="0 0 93.876 59.4" {...props}>
      <g
        data-name="Group 109"
        transform="translate(-468.869 -550.75)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          data-name="Line 205"
          transform="translate(469.369 609.65)"
          stroke="#1a1818"
          strokeWidth={1}
          d="M0 0L92.876 0"
        />
        <path
          data-name="Path 783"
          d="M504.317 577.892c1.515 5.572 4.875 13.81 11.5 13.81s9.981-8.238 11.5-13.81"
          stroke="#1a1818"
          strokeWidth={1.002}
        />
        <path
          data-name="Path 784"
          d="M522.6 588.763v4.059c0 2.554.924 3.45 3.891 3.45h5.686a6.1 6.1 0 015.92 5.122l.931 4.713"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 785"
          d="M509.017 588.763v4.059c0 2.554-.924 3.45-3.891 3.45h-5.686a6.1 6.1 0 00-5.92 5.122l-.931 4.713"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 786" d="M526.248 596.4a12.386 12.386 0 01-20.951-.132" stroke="#ea3e3b" strokeWidth={1} />
        <path
          data-name="Path 787"
          d="M512.878 584.218a1.035 1.035 0 001.045.6h4.064a1.035 1.035 0 001.046-.6"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 788" d="M514.831 586.536a2.071 2.071 0 002.248 0" stroke="#1a1818" strokeWidth={1} />
        <path data-name="Path 789" d="M514.356 579.875a2.136 2.136 0 003.2 0" stroke="#1a1818" strokeWidth={1.001} />
        <path
          data-name="Path 790"
          d="M507.64 573.952a3.153 3.153 0 012.081-.749 3.074 3.074 0 012.31.979"
          stroke="#1a1818"
          strokeWidth={0.998}
        />
        <path
          data-name="Path 791"
          d="M509.72 573.2a.819.819 0 11-.819.819.819.819 0 01.819-.819z"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 792"
          d="M524.272 573.952a3.153 3.153 0 00-2.081-.749 3.076 3.076 0 00-2.311.979"
          stroke="#1a1818"
          strokeWidth={0.998}
        />
        <path
          data-name="Path 793"
          d="M522.19 573.2a.819.819 0 10.819.819.819.819 0 00-.819-.819z"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 794" d="M506.915 571.778a16.88 16.88 0 015.8-.664" stroke="#1a1818" strokeWidth={1} />
        <path data-name="Path 795" d="M525 571.778a16.88 16.88 0 00-5.8-.664" stroke="#1a1818" strokeWidth={1} />
        <path
          data-name="Path 796"
          d="M501 572.672v-9.315a12.142 12.142 0 0112.106-12.107h5.415a12.143 12.143 0 0112.106 12.107v9.315"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 797"
          d="M515.955 560.859h6.079a5.687 5.687 0 015.67 5.67v7.4m-23.782 0v-7.4"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 798" d="M504.317 577.892a3.663 3.663 0 01-.408-7.3" stroke="#1a1818" strokeWidth={1} />
        <path data-name="Path 799" d="M527.309 577.892a3.663 3.663 0 00.408-7.3" stroke="#1a1818" strokeWidth={1} />
        <path
          data-name="Path 800"
          d="M502.891 566.184c5.215-.769 11.472-.549 13.064-5.324"
          stroke="#1a1818"
          strokeWidth={1}
        />
      </g>
    </svg>
  )
}

export default MaleIcon
